import { useQuery } from '@tanstack/react-query';
import { useBuilderVocabularyApi } from '../services/api/useBuilderVocabulary.api';
import { useGenderApi } from '../services/api/useGender.api';
import { BuilderVocabularyItem } from '../types/SimilarlySituated/BuilderVocabularyItem.type';
import { BuilderVocabulary } from '../types/SimilarlySituated/BuilderVocabulary.type';

/**
 * Switcher for fetching builder vocabulary items, based on the type
 */
export function useBuilderVocabulary(vocabulary: BuilderVocabulary) {
  const {
    getBuilderStages,
    getBuilderStatuteLevels,
    getBuilderStagePositions,
    getBuilderCaseDispositions,
    getBuilderAges,
    getBuilderCodefendantStatuses,
    getBuilderDateWindowStages,
    getBuilderOffenceGroupingTypes,
  } = useBuilderVocabularyApi();
  const { getGenders } = useGenderApi();

  return useQuery<BuilderVocabularyItem[]>({
    queryKey: ['builderVocabulary', vocabulary],
    queryFn: async () => {
      switch (vocabulary) {
        case 'stage': {
          const stages = await getBuilderStages();
          return stages.filter((stage) => !stage.is_hidden);
        }
        case 'statute-level':
          return getBuilderStatuteLevels();
        case 'position':
          return getBuilderStagePositions();
        case 'disposition':
          return getBuilderCaseDispositions();
        case 'age':
          return getBuilderAges();
        case 'codefendant':
          return getBuilderCodefendantStatuses();
        case 'date-window-stage':
          return getBuilderDateWindowStages();
        case 'offence-grouping':
          return getBuilderOffenceGroupingTypes();
        case 'gender':
          return getGenders(true);
      }
    },
    staleTime: Infinity,
  });
}
